"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { cn } from "@/lib/utils/cn";
import { HeroFallback } from "./HeroFallback";

const HeroScene = dynamic(() => import("./HeroScene"), {
  ssr: false,
  loading: () => <HeroFallback />,
});

interface HeroSceneWrapperProps {
  /** Override the default size classes (w/h). Uses tailwind-merge so callers
      can pass arbitrary widths like "w-[200px] h-[200px]". */
  className?: string;
}

export function HeroSceneWrapper({ className }: HeroSceneWrapperProps = {}) {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    // Only load the WebGL bundle on desktop with motion allowed.
    // Sync from media-query state on mount; one-shot, not a cascade.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setShouldAnimate(!reducedMotion && !isMobile);
  }, []);

  return (
    <div
      className={cn(
        "relative flex aspect-square w-[280px] items-center justify-center sm:w-[360px] lg:w-[520px]",
        className
      )}
    >
      {shouldAnimate ? <HeroScene /> : <HeroFallback preload />}
    </div>
  );
}
